<div id="loadingMsg" class="">
    <h1>LOADING...</h1>
</div>
<br>
<br>

<div class="container main-content pt-5 col-lg-10 col-12">
  <div class="custom-card mx-auto" style="max-width: 50rem; align-items: center;">
      <div class="row align-items-center mb-3 justify-content-between">
        <h2 class="custom-card-title">Registration</h2>
        <div id="signUpForm" class="fixed loginCard hidden">
            <form [formGroup]="createForm">
                <div id="nameBar">
                  <div class="row g-1 mb-2">
                    <div class="titles col-2">
                      <select class="form-select" name="title" id="title" formControlName="title">
                        <option value="">Title</option>
                        <option value="Mr.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Mr.">Mr.</option>
                        <option value="Dr.">Dr.</option>
                        <option value=" ">&nbsp;</option>
                      </select>
                    </div>
                    <div class="col-4"> <input class="form-control" type="name" placeholder="First Name" formControlName="firstName"></div>
                    <div class="col-2"><input class="form-control" type="text" placeholder="M.I." formControlName="middleInit" id="middle" maxlength="1"></div>
                    <div class="col-4"> <input class="form-control" type="name" placeholder="Last Name" formControlName="lastName"></div>
                  </div>

                </div>
                <div id="roles" class="mb-2">
                  <select name="role" id="role" formControlName="role" class="form-select">
                    <option value="">Role</option>
                    <option value="GHS Teacher Representative">GHS Teacher Representative</option>
                    <option value="Teacher">Teacher</option>
                  </select>
                </div>

                <div id="schoolBar">
                  <div class="row g-1 mb-2">
                    <div class="col-3">  <div class="grades">
                      <select name="grades" id="grades" formControlName="grade" class="form-select">
                        <option value="">Grade</option>
                        <option value="All Grades">All Grades</option>
                        <option value="K">K</option>
                        <option value="1st">1st</option>
                        <option value="2nd">2nd</option>
                        <option value="3rd">3rd</option>
                        <option value="4th">4th</option>
                        <option value="5th">5th</option>
                        <option value="6th">6th</option>
                        <option value="7th">7th</option>
                        <option value="8th">8th</option>
                        <option value="9th">9th</option>
                        <option value="10th">10th</option>
                        <option value="11th">11th</option>
                        <option value="12th">12th</option>
                      </select>
                    </div></div>
                    <div class="col-9"> <div class="school">
                      <select name="schools" id="schools" formControlName="school" class="form-select">
                        <option value="">School</option>
                        <option value="{{school.name}}" *ngFor="let school of schools">{{school.name}}</option>
                      </select>
                    </div> </div>
                  </div>
                </div>

                <div id="emailBar" class="mb-2">
                    <input type="email" placeholder="Email" formControlName="email" class="form-control">
                </div>
                <div id="passBar">

                  <div class="row row-cols-2 g-2 mb-2">
                    <div class="col"><input type="password" placeholder="Password" name="Password" formControlName="password" class="form-control"></div>
                    <div class="col"><input type="password" placeholder="Password Confirmation" formControlName="passCOnf" class="form-control"></div>
                  </div>

                </div>
                <div id="buttonCont">
                    <button type="submit" class="btn btn-primary me-2" (click)="submitAcct()">SUBMIT</button>
                    <a class="btn btn-secondary" href="/landing">CANCEL</a>
                </div>
            </form>
        </div>
      </div>
  </div>
</div>
<br>
<br>
